import { render, staticRenderFns } from "./WeightAlert.vue?vue&type=template&id=2515171c&scoped=true"
import script from "./WeightAlert.vue?vue&type=script&lang=js"
export * from "./WeightAlert.vue?vue&type=script&lang=js"
import style0 from "./WeightAlert.vue?vue&type=style&index=0&id=2515171c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2515171c",
  null
  
)

export default component.exports